import React from "react";
import { motion } from "framer-motion";
import { XIcon, CheckIcon } from "lucide-react";
const without = ["Refinamientos constantes", "Casos que nunca terminan", "Setups aprobados por intuición", "Ataches colocados automáticamente", "IPR improvisado", "Pacientes frustrados", "Baja rentabilidad"];
const withSystem = ["Menos refinamientos evitables", "Tratamientos más predecibles", "Planificaciones con criterio clínico", "Ataches seleccionados estratégicamente", "Protocolos claros de desgaste interproximal", "Pacientes con expectativas realistas", "Casos más eficientes"];
export function ProblemSolution() {
  return <section className="bg-navy-50 px-5 py-12" data-id="element-169" data-mp="9hexl6v3eg9o">
      <div className="mx-auto max-w-md" data-id="element-170" data-mp="4jluimp362dm">
        <h2 className="text-center font-display text-2xl font-extrabold leading-tight text-navy-800 sm:text-3xl" data-id="element-171" data-mp="4ikdm1le2lnz">
          Menos refinamientos.
          <br data-id="element-172" data-mp="x92eqx2jycyr" />
          Más control. <span className="text-brand" data-id="element-173" data-mp="x7rg1bnyrvei">Más rentabilidad.</span>
        </h2>

        <div className="mt-5 space-y-4 text-sm leading-relaxed text-navy-800/70" data-id="element-174" data-mp="6tk5vvk6qx0z">
          <p data-id="element-175" data-mp="bs56hw3cnipy">
            Cada refinamiento representa más citas, más tiempo de sillón, más desgaste y menos
            utilidad para tu consulta.
          </p>
          <p data-id="element-176" data-mp="3u3sa2o910631">
            El problema es que la mayoría de esos refinamientos no comienzan al final del tratamiento.{" "}
            <strong className="text-navy-800" data-id="element-177" data-mp="3k7ovgiwzmez7">Comienzan mucho antes.</strong>
          </p>
          <div className="flex flex-wrap justify-center gap-2 py-1" data-id="element-178" data-mp="3p6id8njb4s56">
            {["En el diagnóstico", "En la planificación", "En la biomecánica", "En la aprobación del setup"].map(t => <span key={t} className="rounded-full bg-white px-3 py-1 text-xs font-semibold text-navy-800 shadow-sm" data-id="element-179" data-mp="3f82hu8d8ywpv">
                  {t}
                </span>)}
          </div>
          <p data-id="element-180" data-mp="1dg6730ywlqw5">
            El Sistema Antirrefinamientos reúne los protocolos clínicos que te permiten detectar esos
            errores antes de que se conviertan en <strong className="text-navy-800" data-id="element-181" data-mp="2hejo8i8986wu">meses adicionales de tratamiento.</strong>
          </p>
        </div>

        <p className="mt-8 text-center font-display text-lg font-bold text-navy-800" data-id="element-182" data-mp="2de0vmlyjewtl">
          De tratamientos impredecibles… a casos mucho más <span className="text-brand" data-id="element-183" data-mp="28g7nhndobsqo">predecibles.</span>
        </p>

        <div className="mt-6 space-y-4" data-id="element-184" data-mp="35343ebpmupaz">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl border-2 border-red-200 bg-white p-5" data-id="element-185" data-mp="312sges9sscwc">
            <div className="mb-3 flex items-center gap-2 font-display text-base font-bold text-red-600" data-id="element-186" data-mp="2rbxu5nwjxdaw">
              <span className="text-xl" data-id="element-187" data-mp="3otg0sd0wguzs">❌</span> Sin un sistema
            </div>
            <ul className="space-y-2.5" data-id="element-188" data-mp="3k14umsfkgcys">
              {without.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-navy-800/70" data-id="element-189" data-mp="3rd2mt3zv5x2b">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-500" data-id="element-190" data-mp="6hyhs17138z" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="rounded-2xl border-2 border-brand bg-brand/5 p-5" data-id="element-191" data-mp="57pbq6m3uun1">
            <div className="mb-3 flex items-center gap-2 font-display text-base font-bold text-brand-dark" data-id="element-192" data-mp="j3syxfyka2q0">
              <span className="text-xl" data-id="element-193" data-mp="nwvv7vuq3q9w">✅</span> Con Sistema Antirrefinamientos
            </div>
            <ul className="space-y-2.5" data-id="element-194" data-mp="sudvkxuocx6a">
              {withSystem.map(item => <li key={item} className="flex items-start gap-2.5 text-sm font-medium text-navy-800" data-id="element-195" data-mp="wy3f38whsokg">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" data-id="element-196" data-mp="11weqvp6cl95b" />
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}